import { RefObject, useEffect, useCallback } from "react";

export const useOutsideClick = (
  // Accept any element ref (div, button, …) — the hook only needs `contains`.
  refs: RefObject<HTMLElement>[],
  outsideClickHandler: () => any,
) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const isOutside = refs.every(
        (ref: RefObject<HTMLElement>) =>
          ref.current && !ref.current.contains(event.target as Node),
      );

      if (isOutside) {
        outsideClickHandler();
      }
    },
    [outsideClickHandler, refs],
  );

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.addEventListener("mousedown", handleClickOutside);

      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [handleClickOutside]);
};
